import React, { useState, useEffect, useRef } from "react";
import "./Explore.scss";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Row,
  Button,
  Space,
  Divider,
  Tabs,
  Badge,
  Tag,
  Input,
  Spin,
  Modal,
  InputNumber,
  Tooltip, 
} from "antd";
import FindingsDrawer from ".././findings-drawer/FindingsDrawer";
// import Draggable from 'react-draggable';
import { DraggableCore } from 'react-draggable';

import aesEncryt from "../../shared/AesEncryt/AesEncryt";
import {
  DownloadOutlined,
  LoadingOutlined,
  CheckCircleTwoTone,
  PlusCircleOutlined,
  InfoCircleOutlined
} from "@ant-design/icons";
import FilterIcon from "../../assets/icons/filter-icon-white.svg";
import NeutralIcon from "../../assets/icons/Neutral-icon.svg";
import AgreeIcon from "../../assets/icons/Agree-blue-thumb.svg";
import Disagree from "../../assets/icons/Disagree-orange-thumb.svg";
import ExploreOverview from "../explore-overview/ExploreOverview";
import FindingReportSettingsModal from "../finding-report-setting-modal/FindingReportSettingsModal";
import ExploreResponseDetails from "../explore-response-details/ExploreResponseDetails";
import RespondentFilter from "../respondent-filter-drawer/RespondentFilter";
import {
  downloadExploreResponses,
  displayExploreFilterDataAPI,
  saveExploreFilterAPI,
} from "../../services/ExploreAPI";
import {
  setSearchTextExplore,
  setIsFindingsReportFullWidth,
  setExploreFilterApplyData,
  setNavigationTab,
  setFindingsReportAnalysisData,
  setFindingsReportAnalysisId,
  setFindingReportData,
  setIsFindingsReportIsOpen,
  setUserDetail,
  setshowWarningMsg,
  setCallingExploreDisplayFiltersDataAPI,
  setRespondentsCount
} from "../../reducer/PEBCommonSlice";
const { Search } = Input;

function Explore() {
  const location = useLocation();
  const data = location.state;
  const dispatch = useDispatch();
  const [showWarningMsgOnExploreAlso,setShowWarningMsgOnExploreAlso] = useState(false);
  const tabName = useSelector((state) => state.PEBCommon?.tabName); 
  const [showNSizeFilter,setShowNSizeFilter] = useState(false);
  const isFullWidth = useSelector(
    (state) => state.PEBCommon?.findingsReport.isFullWidth
  );
  const editAccessFlag = useSelector(
    (state) => state.PEBCommon?.hasAccessToReport
  );
  const supportingData = useSelector(
    (state) => state.PEBCommon?.supportingData
  );
  const addMultipleCardsApiRunning = useSelector(
      (state) => state.PEBCommon?.addMultipleCardsApiRunning
  
    );
  const loadingDisplayCategoryQuesData = useSelector(
      (state) => state.PEBCommon?.loadingDisplayCategoryQuesData
    );
  const callingExploreDisplayFiltersDataAPI = useSelector(
    (state) => state.PEBCommon?.callingExploreDisplayFiltersDataAPI
  );
  
     const respondentsCount =  useSelector(
        (state) => state.PEBCommon?.respondentsCount
      );
     const userInfo = useSelector((state) => state.PEBCommon?.userDetail); // get User details
    const environment = userInfo?.environment || "";

     const [position, setPosition] = useState(() => {
      if (userInfo?.pilot_active && !showWarningMsgOnExploreAlso && tabName != "Data Coverage" && tabName != "" ) {
        return { x: '78.5%', y: 30 };
      }
      else if (userInfo?.pilot_active) {
        return { x: '78.5%', y: 160 };
      }
      return { x: '78.5%', y: 265 };
    });
    useEffect(() => {
      if (userInfo?.pilot_active && !showWarningMsgOnExploreAlso && tabName != "Data Coverage" && tabName != "" ) {
        setPosition({ x: '78.5%', y: 30 });
      }
      else if (userInfo?.pilot_active) {
        setPosition({ x: '78.5%', y: 160 });
      }
      else {
        setPosition({ x: '78.5%', y: 265 });
      }
    }, [userInfo?.pilot_active, showWarningMsgOnExploreAlso, tabName]);

    const initialPosition={x:0,y:0};
    const handleDrag = (e, data) => {
      // console.log("window.innerWidth",window.innerWidth); // 1362
      // console.log("data.x;",data.x);
      
      // console.log("window.innerHeight",window.innerHeight); //997
      
      let zoomLevelMultiplier = 0.95;
      if(window.devicePixelRatio>=1.2){
        zoomLevelMultiplier = 0.9;
      }
      const maxX = window.innerWidth - window.innerWidth*20/100;   // max allowed x coordinate
      const maxY = window.innerHeight*zoomLevelMultiplier; // max allowed y coordinate
      const minimumMultiplier= 0.75;
      // const maxY = window.screen.height*2*Math.max(window.devicePixelRatio,minimumMultiplier);
    
      let newX = data.x;
      let newY = data.y;
    
      if (newX < window.innerWidth/20) newX = window.innerWidth/20;
      else if (newX > maxX) newX = maxX;
    
      if (newY < 0) newY = 0;
      else if (newY > maxY) newY = maxY;
      setPosition({ x: newX, y: newY });
    };
    // addition - zoom/resize handling
    useEffect(() => {      
      const handleViewportChange = () => {
        // Same boundary calculations as per handleDrag
        // const maxX = window.innerWidth - window.innerWidth*26/100;
        // const minimumMultiplier = 0.75;
        // const maxY = window.screen.height*2*Math.max(window.devicePixelRatio, minimumMultiplier);
        let zoomLevelMultiplier = 0.95;
        if(window.devicePixelRatio>=1.2){
          zoomLevelMultiplier = 0.9;
        }
        const maxX = window.innerWidth - window.innerWidth*24/100;   // max allowed x coordinate
        const maxY = window.innerHeight*zoomLevelMultiplier; // max allowed y coordinate
        setPosition(prevPosition => {
          let newX = prevPosition.x;
          let newY = prevPosition.y;

          if (newX < window.innerWidth/20) newX = window.innerWidth/20;
          else if (newX > maxX) newX = maxX;

          if (newY < 0) newY = 0;
          else if (newY > maxY) newY = maxY;

          return { x: newX, y: newY };
        });
      };

      let resizeTimeout;
      const debouncedHandler = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleViewportChange, 100);
      };

      window.addEventListener('resize', debouncedHandler);
      
      return () => {
        window.removeEventListener('resize', debouncedHandler);
        clearTimeout(resizeTimeout);
      };
    }, []);
    // const handleDrag = throttle((e, data) => {
    //   setPosition({ x: data.x, y: data.y });
    // }, 16);
  
  const filterData = useSelector((state) => state.PEBCommon?.filterData);
  const recordData = useSelector((state) => state.PEBCommon?.recordData);
  const isOpen = useSelector((state) => state.PEBCommon?.findingsReport.isOpen);
 
  const filterAppliedData = useSelector(
    (state) => state.PEBCommon?.exploreFilterApplyData
  ); 
  
  function allComparatorsEmpty(dataArray) {
    return !dataArray?.some(obj => obj.is_empty_comparator === false);
  }

  const showWarningMsg = useSelector((state)=>state.PEBCommon?.pilot.showWarningMsg);

  const shouldShowPopup = () => {
    if (userInfo?.pilot_active && !allComparatorsEmpty(filterAppliedData) ) {
      return true;
    }
    return false;
  };
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);

  
  useEffect(()=>{    
    setShowWarningMsgOnExploreAlso(shouldShowPopup());
  },[showWarningMsg,filterAppliedData]);

  useEffect(()=>{
    setShowNSizeFilter(false);
    if(tabName != "" && tabName!="Data Coverage" &&
 !addMultipleCardsApiRunning  && !loadingDisplayCategoryQuesData && !callingExploreDisplayFiltersDataAPI && !isLoadingDetails

    ){
      setTimeout(() => {
        setShowNSizeFilter(true);
      }, 2000);
    }
  },[tabName, addMultipleCardsApiRunning , loadingDisplayCategoryQuesData ,callingExploreDisplayFiltersDataAPI , isLoadingDetails])
  
  const userId = userInfo.user_id;
  const tabDefaultValue = data?.tabValue ? data.tabValue : "1";
  const [respondentFilterFlag, setRespondentFilterFlag] = useState(false);
  const [tags, setTags] = useState([]);
  let [extraKeys, setExtraKeys] = useState();
  const idmUrl = process.env.REACT_APP_IDM_URL;
  const [isOpenModal, setIsOpen] = useState(false);
  // const surveyButtonClicked = () => {};

  let [filterTagCount, setFilterTagCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  
  const searchString = useSelector(
    (state) => state.PEBCommon?.searchTextExplore
  );
  const analysisData = useSelector(
    (state) => state.PEBCommon?.findingsReport.analysisData
  );
  const minimizedOpenedReport = useSelector(
    (state) => state.PEBCommon?.minimizedOpenedReport
  );
  
  const [loading, setLoading] = useState(false);
  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize:30,
      }}
      spin
    />
  );


  const [renderKey, setRenderKey] = useState(0);

  // Trigger re-render logic
  useEffect(() => {
    // Show loader
    // if(addMultipleCardsApiRunning){
      setIsLoadingDetails(true);

      // Wait briefly before rendering the component
      const timeout = setTimeout(() => {
        setRenderKey(Number(addMultipleCardsApiRunning) + Number(!analysisData?.quesMaxUpdatedTs));
        setIsLoadingDetails(false);
      }, 500); // You can tweak this delay
      return () => clearTimeout(timeout);
    // }
   

   
  }, [addMultipleCardsApiRunning, analysisData?.quesMaxUpdatedTs]);


  const [activeKey, setActiveKey] = useState(tabDefaultValue);

  let showWarningMsgOnKeys = ['2', '3'];
  if(showWarningMsgOnExploreAlso){
   showWarningMsgOnKeys = ['1','2', '3'];
  }
  
  const extraContent = showWarningMsgOnKeys.includes(activeKey) && userInfo.pilot_active ? 
  <div className="warning-message">
    <span className="warning-icon">
      <InfoCircleOutlined
          style={{
            marginRight: 2,
            color: '#1890ff',
            // cursor: 'pointer',
            fontSize: '20px'
          }}
        />
        </span>
    <span className="warning-text">
      {tabName === "Data Coverage" || tabName === ""
        ? "The Data Coverage screen displays summaries based on your data access & restrictions once you apply the filters"
        : "This screen displays summaries based on your data access and restrictions" 
      }
    </span>
  </div>
  : null;



  if (!isOpen) {
    localStorage.removeItem("analysisId");
    localStorage.removeItem("suppCardOrder");
  }
  const respondantFilterOpen = (state) => {
    setRespondentFilterFlag(state);

    if (!state) displayFilterDataPayload();
  };
  const options = [];
  for (let i = 10; i < 36; i++) {
    options.push({
      value: i.toString(36) + i,
      label: i.toString(36) + i,
    });
  }
  useEffect(() => {
    setRespondentFilterFlag(false);
  }, [editAccessFlag]);


  // Confidentiality banner component - reusable
  const ConfidentialityBanner = () => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '10px 16px',
        marginBottom: 16,
        background: "#f5f5f5",
        border: "1px solid #e8e8e8",
        borderLeft: "3px solid #bfbfbf",
        borderRadius: 6,
        fontSize: 13,
        color: "#595959",
      }}
    >
      <InfoCircleOutlined
        style={{
        color: "#8c8c8c",
        fontSize: 16,
        marginRight: 10,
        flexShrink: 0,
      }}
      />
      <span style={{ lineHeight: 1.5 }}>
        <strong style={{ color: "#262626" }}>CONFIDENTIALITY AND INTERNAL USE ONLY NOTICE: </strong>  
           This data (including all attachments) is for the sole use of the intended recipient(s), 
          may contain confidential and privileged information, and is for internal use only.  
          Any unauthorized review, use, disclosure, copying, or distribution is strictly prohibited. 
          If you are not the intended recipient, 
          please contact the sender by reply e-mail and destroy all copies of the original message.
      </span>

     
    </div>
  );


  const items = [
    {
      key: "1",
      label: `Data Coverage`,
      children: (
        <ExploreOverview
          updateFilterCountBadge={(event) => filterCountUpdateHandler(event)}
          updateFilterRespondentsTag={(event) =>
            filterRespondentsTagHandler(event)
          }
        />
      ),
    },
    // {
    //   key: "2",
    //   label: `View Insights`,
    //   children: <ExploreResponseDetails key={Number(addMultipleCardsApiRunning) + Number(!analysisData?.quesMaxUpdatedTs)} screenName="responses" />,
    // },
    {
      key: "2",
      label: `View Insights`,
      children: (
        <div style={{ minHeight: "300px", position: "relative" }}>
          {isLoadingDetails ? (
            <Spin
              // tip="Loading insights..."
              style={{
                position: "fixed",
                top: "40.5%",
                left: "50.5%",
                transform: "translate(-50%, -50%)",
              }}
              indicator={antIcon}
            />
            // <></>
          ) : (
          <>
             {(environment === "prod_client_1") && <ConfidentialityBanner />}
            <ExploreResponseDetails
              key={renderKey}
              screenName="responses"
            />
          </>
        )}
        </div>
      ),
    },
    {
      key: "3",
      label: `View Use Cases`,
      children: (
      <>
      {(environment === "prod_client_1") && <ConfidentialityBanner />}
        <ExploreResponseDetails screenName="View Use Case" />
      </>
    ),
    },
  ];

  //lehgend Popover Content for Responses Tab
  const content = (
    <div>
      <span style={{ paddingRight: 15 }}>
        {" "}
        <img
          alt={"Agree Icon"}
          src={AgreeIcon}
          style={{ verticalAlign: "text-bottom", paddingRight: 5 }}
        />
        Agree
      </span>
      <span style={{ paddingRight: 15 }}>
        <img
          alt={"Disagree"}
          src={Disagree}
          style={{ verticalAlign: "text-bottom", paddingRight: 5 }}
        />
        Disagree
      </span>
      <span style={{ paddingRight: 15 }}>
        <img
          alt={"Neutral Icon"}
          src={NeutralIcon}
          style={{ verticalAlign: "text-bottom", paddingRight: 5 }}
        />
        Neutral
      </span>
    </div>
  );

  const onChange = (key) => {
     setActiveKey(key);
    // if (key === "2") {
    //   setExtraKeys(
    //     <>
    //       <Popover placement="bottomRight" content={content}>
    //         <div>
    //           <InfoCircleOutlined /> <span>Legend</span>
    //         </div>
    //       </Popover>
    //     </>
    //   );
    // } else {
    //   setExtraKeys();
    // }
  };

  const handleClose = (removedTagObj) => {
    let removedTag = removedTagObj.comparator_name;
    setLoading(true);
    const newTags = tags.filter((tag) => tag !== removedTag);

    deleteFilterTagData(removedTag);
    setTags(newTags);
    // setLoading(false);
  };

  const deleteFilterTagData = (removedTag) => {
    let updatedFilterData =
      filterAppliedData.length === 1
        ? [
            {
              therapeutic_area: [],
              indication: [],
              age: [],
              sub_indication: [],
              ethnicity: [],
              geography: [],
              origin_country: [],
              race: [],
              gender: [],
              comparator_name: "Criteria 1",
              primary_flag: true,
            },
          ]
        : filterAppliedData.filter(
            (data) => data.comparator_name !== removedTag
          );
    updatedFilterData = updatedFilterData.map((filter) => {
      return {
        therapeutic_area: filter.therapeutic_area || [],
        primary_indication: filter.primary_indication || [],
        other_indication:filter.other_indication || [],
        age: filter.age || [],
        mapped_data: filter.mapped_data || [],
        sub_indication: filter.sub_indication || [],
        ethnicity: filter.ethnicity || [],
        geography: filter.geography || [],
        origin_country: filter.origin_country || [],
        race: filter.race || [],
        gender: filter.gender || [],
        comparator_name: filter.comparator_name,
        primary_flag: filter.primary_flag,
        other_mapped_data: filter.other_mapped_data || [],
        year_range : filter.year_range || [],
        stage : filter.stage || [],
        survey_year : filter.survey_year || [],
        survey_year_mapped_data : filter.survey_year_mapped_data || [],
        category_name: filter.category || [],
        lov_id : filter.lov_id || [],
        lov_id_mapped_data : filter.lov_id_mapped_data || [],
        lov_id_options: filter.lov_id_options || [],
        ques_alias : filter.ques_alias || [],
        ques_id : filter.ques_id || [],
        ques_type : filter.ques_type || [],
        comparator_id: filter.comparator_id || null,
        custom_region:filter.custom_region || [],
        geo_state:filter.geo_state || [],
        geo_state_mapped_data: filter.geo_state_mapped_data || [],
        region:filter.region || []
      };
    });
    // YS added comp-id above in payload when we cross
    //  the criteria from explore page to preserve other id
    let payload = {
      user_id: userId,
      screen_name: "data_coverage",
      comparator_flag: true,
      delete_comparator_names: [removedTag],
      filters_data: updatedFilterData,
      display_chart_nm: [],
      analysis_id: localStorage.getItem("analysisId") || "",
    };
    saveFilterData(payload);
  };

  const saveFilterData = async (payload) => {
    let response = await saveExploreFilterAPI(payload);

    displayFilterDataPayload();
  };

  //to search the Questions and categories
  const onSearch = (e) => {
    setSearchTerm(e.target.value);
  };
  const handleSearch = () => {
    if (searchTerm.length > 2 || searchTerm.length === 0) {
      dispatch(setSearchTextExplore(searchTerm));
    }
  };

  function getCookie(name) {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // Check if the cookie starts with the specified name
      if (cookie.startsWith(name + "=")) {
        // Return the value of the cookie
        return cookie.substring(name.length + 1); // Remove the name and '=' from the beginning
      }
    }
    // Return null if the cookie is not found
    return null;
  }
  function redirectToAnalysisLibrary(id) {
    const redirectToAnalysisLibraryUrl = process.env.PUBLIC_URL;
    window.location.href = `${redirectToAnalysisLibraryUrl}/analysis-library?id=${id}`;
  }
  function deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
  useEffect(() => {
    displayFilterDataPayload();
    dispatch(setIsFindingsReportFullWidth(false));
    dispatch(setNavigationTab("/explore"));
    const idFromCookie = getCookie("id");
    // If 'id' exists in the cookie, redirect to the analysis library
    if (idFromCookie) {
      deleteCookie("id");
      redirectToAnalysisLibrary(idFromCookie);
    }
    // if (editAccessFlag === false) {
    //   dispatch(setIsFindingsReportIsOpen(false));
    //   dispatch(setIsFindingsReportFullWidth(false));
    //   dispatch(setFindingReportData({ insight_list: [], supporting_data: [] }));
    //   dispatch(setFindingsReportAnalysisId(null));
    //   dispatch(setFindingsReportAnalysisData({}));
    // }
  }, []);

  useEffect(() => {
    const debounceId = setTimeout(() => {
      if (searchTerm.length > 2 || searchTerm.length === 0) {
        dispatch(setSearchTextExplore(searchTerm));
      }
    }, 1000);

    // Clear the timeout on unmount or when the searchTerm changes
    return () => clearTimeout(debounceId);
  }, [searchTerm]);

  //to Download Explore Screen Responses
  const downloadClicked = async () => {
    sessionStorage.setItem("Download", "yes");
    const payload = {
      user_id: userId,
      screen_name: "data_coverage",
      analysis_id: localStorage.getItem("analysisId") || "",
    };

    let response = await downloadExploreResponses(payload);
    window.open(aesEncryt(response?.export_url), "_parent");
    sessionStorage.setItem("Download", "no");
  };
  const modalOpen = async () => {
    setIsOpen(true);
  };

  const filterCountUpdateHandler = (count) => {
    setFilterTagCount(count);
  };

  const filterRespondentsTagHandler = (tags) => {
    setTags(tags);
  };

  const displayFilterDataPayload = () => {
    let payload = {
      user_id: userId,
      screen_name: "data_coverage",
      analysis_id: localStorage.getItem("analysisId") || "",
      analysis_refresh_date: analysisData?.last_updated || "",
      ques_max_updated_ts: analysisData?.quesMaxUpdatedTs || "",
      allowed_geographies: userInfo?.allowed_geographies || [],
      allowed_indications:userInfo?.allowed_indications || [],
    };
    dispatch(setCallingExploreDisplayFiltersDataAPI(true));
    displayFilterData(payload);
  };

  let filterCountBadge = 0;
  let filterRespondentsTag = [];
  //API call to Display Filters Data
  const displayFilterData = async (payload) => {
    setLoading(true);
    dispatch(setCallingExploreDisplayFiltersDataAPI(true));
    let response = await displayExploreFilterDataAPI(payload);

    filterCountBadge = 0;
    filterRespondentsTag = [];
    // if (!filterAppliedData)

    // TO PREVENT UPDATING OF FILTER DATA FROM API

    if (
      JSON.stringify(response?.result?.filters_data) !==
      JSON.stringify(filterAppliedData)
    ) {
      // Dispatch the action only if there's a change
      dispatch(setExploreFilterApplyData(response?.result?.filters_data));
    }
    if (Object.keys(response?.result).length) {
      response?.result?.filters_data.forEach((comp) => {
        Object.keys(comp).forEach((column) => {
          let columnsToExclude = [
            "comparator_name",
            "primary_flag",
            "indication",
            "sub_indication",
            "no_of_respondents",
            "comparator_order",
            "lov_id_options",
            "comparator_id"
          ];
          if (!columnsToExclude.includes(column) && comp[column]?.length) {
            filterCountBadge++;
          }
        });
        if (comp["indication"]?.length || comp["sub_indication"]?.length)
          filterCountBadge++;
        else if (
          response?.result?.filters_data.length &&
          comp["comparator_name"]
        ) {
        }
        filterRespondentsTag.push({
          comparator_name: comp["comparator_name"],
          no_of_respondents: comp["no_of_respondents"],
          no_of_respondents_insights: comp["no_of_respondents_insights"]
        });
      });
    }

    filterCountUpdateHandler(filterCountBadge);
    filterRespondentsTagHandler(filterRespondentsTag);
    setLoading(false);
    dispatch(setCallingExploreDisplayFiltersDataAPI(false));
  };

  useEffect(() => {
    const isAnyvalEmpty = Object.values(analysisData).some(
      (value) => value == ""
    );
    if (!isAnyvalEmpty) {
      displayFilterDataPayload();
    }
  }, [analysisData]);

  return (
    <>
    
      <Modal
        open={showWarningMsg}
        // open={true}
        footer={null}
        onCancel={() => dispatch(setshowWarningMsg(false))}
        closable={true}
        centered
        width={560}
        className="custom-info-modal"
        styles={{
          content: {
            padding: 0,
            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
          }
        }}
      >
        {/* Header Section */}
        <div style={{
          padding: '20px 20px 0 20px',
          background: '#ffffff',
          textAlign: 'center'
        }}>
          <div style={{
            width: '64px',
            height: '64px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px auto',
            boxShadow: '0 8px 25px rgba(37, 99, 235, 0.25)'
          }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 16H12V12H11M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                    stroke="white" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"/>
            </svg>
          </div>
          
          <h2 style={{
            margin: '0 0 8px 0',
            fontSize: '24px',
            fontWeight: '700',
            color: '#111827',
            letterSpacing: '-0.025em',
            lineHeight: '1.25'
          }}>
            Data Coverage Notice
          </h2>
          
          <p style={{
            margin: '0 0 32px 0',
            fontSize: '16px',
            color: '#6b7280',
            lineHeight: '1.5',
            fontWeight: '400'
          }}>
            Important information about filtered data display
          </p>
        </div>

        {/* Content Section */}
        <div style={{
          padding: '0 32px 32px 32px',
          background: '#ffffff'
        }}>
          {/* Main Message */}
          <div style={{
            padding: '24px',
            background: '#f8fafc',
            borderRadius: '12px',
            border: '1px solid #e2e8f0',
            marginBottom: '24px'
          }}>
            <p style={{
              margin: 0,
              fontSize: '16px',
              lineHeight: '1.6',
              color: '#374151',
              textAlign: 'center'
            }}>
             The Data Coverage screen displays summaries based on your data access & restrictions once you apply the filters
            </p>
          </div>
          
          {/* Additional Info */}
          <div style={{
            display: 'flex',
            alignItems: 'flex-start',
            padding: '20px',
            background: 'linear-gradient(135deg, #ecfdf5 0%, #f0fdf4 100%)',
            borderRadius: '12px',
            border: '1px solid #bbf7d0',
            marginBottom: '32px'
          }}>
            <div style={{
              width: '20px',
              height: '20px',
              borderRadius: '50%',
              background: '#059669',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '12px',
              marginTop: '2px',
              flexShrink: 0
            }}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 6L9 17L4 12" 
                      stroke="white" 
                      strokeWidth="2.5" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"/>
              </svg>
            </div>
            <div>
              <h4 style={{
                margin: '0 0 4px 0',
                fontSize: '14px',
                fontWeight: '600',
                color: '#065f46',
                lineHeight: '1.4'
              }}>
                Data Security Enabled
              </h4>
              <p style={{
                margin: 0,
                fontSize: '14px',
                color: '#047857',
                lineHeight: '1.5'
              }}>
                This ensures you see only the data you have permission to access
              </p>
            </div>
          </div>
          
          {/* Action Button */}
          <div style={{
            display: 'flex',
            justifyContent: 'center'
          }}>
            <button
              onClick={() => dispatch(setshowWarningMsg(false))}
              style={{
                padding: '12px 32px',
                border: 'none',
                borderRadius: '8px',
                background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
                color: 'white',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: '0 4px 12px rgba(37, 99, 235, 0.25)',
                minWidth: '120px',
                letterSpacing: '0.025em'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 8px 20px rgba(37, 99, 235, 0.35)';
                e.target.style.background = 'linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 12px rgba(37, 99, 235, 0.25)';
                e.target.style.background = 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)';
              }}
            >
              Understood
            </button>
          </div>
        </div>
      </Modal>
      {isOpenModal && (
        <FindingReportSettingsModal
          isOpen={isOpenModal}
          setIsOpen={setIsOpen}
          supporting_data={supportingData}
          filterData={filterData}
          recordData={recordData}
          type={"category_responses"}
          addFlag={false}
          createAddFlag={true}
        />
      )}
      
      <Spin indicator={antIcon} spinning={loading}
       style={{
        position: "fixed",
        top: "40%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
      >
        <Row wrap={false}>
          {
            <Col
              flex="auto"
              style={{
                marginLeft: 8,
                marginRight: 8,
                padding: "24px 14px",
                display: isFullWidth ? "none" : "block",
              }}
            >
              <Row style={{ marginTop: 10, marginBottom: 20 }}>
                <Col span={12}>
                  <span className="sub-header">
                    {filterTagCount < 1
                      ? `Explore Data from ${
                          tabName === "" || tabName==="Data Coverage" // Replace with your actual first tab name
                            ? tags[0]?.no_of_respondents
                                ? tags[0]?.no_of_respondents.toLocaleString()
                                : ""
                            : tags[0]?.no_of_respondents_insights
                                ? tags[0]?.no_of_respondents_insights.toLocaleString()
                                : ""
                        } Respondents`
                      : "Explore"}
                  </span>
                </Col>
                <Col span={12} style={{ float: "right" }}>
                  <Space style={{ float: "right" }}>
                    {/* <Button
                className="configure-btn"
                onClick={() => surveyButtonClicked()}
              >
                <img
                  alt={"Survey Insights Icon"}
                  src={SurveyInsightsIcon}
                  style={{ verticalAlign: "text-bottom", paddingRight: 5 }}
                />
                Survey for More Insights
              </Button> */}
                    <Space
                      direction="vertical"
                      style={{ display: "flex", alignItems: "flex-end" }}
                      Size={7}
                    >
                      <Button
                        style={{ width: 40 }}
                        className="configure-btn"
                        icon={<DownloadOutlined />}
                        onClick={() => downloadClicked()}
                      ></Button>
                    </Space>
                  </Space>
                </Col>
              </Row>
              <Row>
                <Col style={{ marginRight: "10px", marginTop: "10px" }}>
                  <Space direction="vertical" style={{ float: "left" }}>
                    <Search
                      placeholder="Search Questions that contains the phrase/keyword"
                      onChange={onSearch}
                      onSearch={handleSearch} // This will be triggered when Enter is pressed
                      value={searchTerm} // Controlled input value
                      // size={"large"}
                      enterButton={false}
                      style={{ width: 400, borderRadius: "0px" }}
                    />
                  </Space>
                <Space>
                  <Divider type="vertical" className="divider-vertical" />
                  <Badge
                    size="default"
                    color="#027AFF"
                    count={
                      filterTagCount != 0 ? (
                        <CheckCircleTwoTone style={{ fontSize: "18px" }} />
                      ) : (
                        0
                      )
                    }
                  >
                    <Button
                      className="analysis-btn"
                      type="primary"
                      style={{ height: 40 }}

                      onClick={() => respondantFilterOpen(true)}
                    >
                      <img
                        alt={"Filter Icon"}
                        src={FilterIcon}
                        style={{
                          verticalAlign: "text-bottom",
                          paddingRight: 5,
                        }}
                      />
                      Define Target Population{" "}
                    </Button>
                  </Badge>
                </Space>
                </Col>
                <Space style={{ marginLeft: "auto" }}>
                  {" "}
                  <Button
                    style={{ height: 40 , marginTop:'5px'
                      , paddingRight:'20px' , paddingLeft:'15px' , paddingTop:'10px' , paddingBottom:'15px' }}
                    type={
                      !localStorage.getItem("analysisId")
                        ? "primary"
                        : undefined
                    }
                    icon={<PlusCircleOutlined />}
                    className={
                      !localStorage.getItem("analysisId")
                        ? "analysis-btn"
                        : undefined
                    }
                    onClick={() => modalOpen()}
                  >
                    Create Export
                  </Button>
                </Space>
              </Row>
              {filterTagCount >= 1 && (
                <Row style={{ marginTop: 20, alignItems: "center" }}>
                  <span className="tags-label">Target Population Count: </span>
                  <Space size={[0, "small"]} wrap style={{ marginLeft: 20 }}>
                    {tags.map((tag) => {
                      return (
                        <Tag
                          key={tag}
                          bordered={true}
                          closable={editAccessFlag}
                          color={tag.no_of_respondents === 0 ? "red" : "blue"}
                          style={{
                            display: "flex",
                            height: 32,
                            alignItems: "center",
                          }}
                          title={tabName === "" || tabName==="Data Coverage"?`${tag.no_of_respondents}: ${tag.comparator_name}`:`${tag.no_of_respondents_insights}: ${tag.comparator_name}`}
                          onClose={
                            !editAccessFlag ? null : () => handleClose(tag)
                          }
                        >
                          <div
                            style={{
                              maxWidth: 250,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <strong>{tabName === "" || tabName==="Data Coverage"?`${tag.no_of_respondents}`:`${tag.no_of_respondents_insights}`}</strong>
                          </div>{" "}
                          : {tag.comparator_name}
                        </Tag>
                      );
                    })}
                  </Space>
                </Row>
              )}
              <div style={{ marginTop: 20 }}>
                <Tabs
                  defaultActiveKey={tabDefaultValue}
                  destroyInactiveTabPane={true}
                  items={items}
                  onChange={onChange}
                  tabBarExtraContent={extraContent}
                />
                
                {/* Filter Section - Right aligned at bottom */}
                {!showNSizeFilter?<></>:
                <div 
                    style={{ 
                      display: 'flex', 
                      justifyContent: 'flex-end', 
                      alignItems: 'center',
                      marginTop: 16,
                      padding: '12px 16px',
                      borderRadius: 6,
                    }}
                  >
                    <Space align="center">
                      <span style={{ 
                        fontSize: '14px', 
                        color: '#595959',
                        fontWeight: 500
                      }}>
                        Filter Questions where number of respondents are ≥
                        {/* Filter Questions (Criteria 1): Min. respondents ≥ */}
                      </span>
                      <InputNumber
                        min={0}
                        value={respondentsCount}
                        max={50000}
                        defaultValue={0}
                        placeholder="Enter value"
                        style={{ 
                          width: 90,
                          borderRadius: 4
                        }}
                        onChange={(value) => {
                          // Handle the input change
                          dispatch(setRespondentsCount(value));
                        }}
                      />
                      <Tooltip
                          title={
                            <div style={{ maxWidth: 300, whiteSpace: 'pre-wrap' }}>
                              Set the threshold for auto-collapsing questions by N-size. Changes are saved automatically as you type.
                            </div>
                          }
                        >
                          
                          <InfoCircleOutlined
                            style={{
                              marginLeft: 3,
                              marginRight:1,
                              color: '#1890ff',
                              cursor: 'pointer',
                              fontSize: '18px'
                            }}
                          />
                        </Tooltip>
                    </Space>
                  </div>
                }

                
              </div>
            </Col>
          }

          {respondentFilterFlag ? (
            <div>
              <RespondentFilter
                visible={true}
                onClose={() => respondantFilterOpen(false)}
              />
            </div>
          ) : (
            ""
          )}
           {/* <Draggable bounds="body">
      <Button  onClick={resetPosition}>Draggable Button</Button>
      </Draggable> */}
          {isOpen && (
            //  <Draggable 
            

           
            // {...(!minimizedOpenedReport?{position:initialPosition}:null)}
            // {...(!minimizedOpenedReport?{disabled:true}:false)}
           
            //  >
            <DraggableCore onDrag={handleDrag}
            // grid={[1,1]}
            > 
            <Col
            // nodeRef={nodeRef}
              style={
                isFullWidth
                  ? { 
                    minWidth: "100%", maxWidth: "100%", zIndex: 998 
                  }
                  : minimizedOpenedReport?{ 
                   
                    // minWidth: "26vw", maxWidth: "26vw", zIndex: 1001
                    minWidth: '20vw',
                    maxWidth: '20vw',
                    position: 'fixed',
                    zIndex: 1001,
                    
                    // for core
                    top: position.y,
                    left: position.x,
                    // transform: `translate3d(${position.x}px, ${position.y}px, 0)`,

                    // for draggable
                    // right: 0,
                    cursor: 'move',
                    // 
                   }:{
                    minWidth: "26vw", maxWidth: "26vw", zIndex: 1001
                   }
              }
            >
              <FindingsDrawer
                isShrinkable={isFullWidth ? true : false}
                isClosable={false}
                isExpandable={isFullWidth ? false : true}
                fullWidth={isFullWidth}
                // ref={nodeRef}
              />
              
            </Col>
            </DraggableCore>
            // </Draggable>
          )}
        </Row>
       
        {/* </div> */}
      </Spin>
    </>
  );
}

export default Explore;
